import styled from 'styled-components';

const ToggleDiv = styled.div<{ active: boolean }>`
  display: none;
  ${({ active }) => active && `display: block;`}
`;

export default ToggleDiv;
